import { BrandDocuments } from '@src/api';

export type PolicyDocumentType = BrandDocuments;
export type DocumentPageType = 'login' | 'registration' | 'policy' | 'support' | 'documents';
